/* eslint-disable @typescript-eslint/no-explicit-any */
import { parse, stringify } from '@tock/query-string';
import { useHistory, useLocation } from 'react-router-dom';

import { Container } from 'ui';
import { Theme, css } from '@emotion/react';
import { Typography } from 'omakase';
import { safeToNumber } from '@tock/coretypes';
import { useActions } from '@tock/shared/utils/connect';
import { useMountEffect } from '@tock/hooks';
import { useState } from 'react';
import PageContent from 'components/ui/PageContent';
import ResetPasswordForm from 'forms/ResetPasswordForm';

// localhost:7001/profile/reset?token=%242a%2412%24x5Wa9ac0lieMcTCFtquwjuLUU6wxQUxgWrVWMIet4YHPKfxkRU9q6&email=corey%40tockhq.com

const ResetPasswordRoute: React.FC = () => {
  const { actions } = useActions();
  const history = useHistory();
  const { search } = useLocation();

  const [emailFromQueryString, setEmailFromQueryString] = useState('');
  const [tokenFromQueryString, setTokenFromQueryString] = useState('');

  useMountEffect(() => {
    const query = parse(search);

    if (!query.email || !query.token) {
      actions.toast.showError('Invalid password reset link');
      history.replace('/');
    } else {
      const email = query.email;
      const token = query.token;
      setEmailFromQueryString(email);
      setTokenFromQueryString(token);
      history.replace({ search: stringify({ ...query, email: undefined, token: undefined }) });
    }
  });

  const handleResetPassword = ({ email, password, token }: any) => {
    return actions.app
      .resetPasswordWithToken(email, password, token)
      .then(handleResetPasswordSuccess)
      .catch(handleResetPasswordFailure);
  };

  const handleResetPasswordFailure = (response: any) => {
    const errorCode = safeToNumber(response?.error?.errorCode ?? 0);
    if (errorCode === 5008) {
      // RESET_LINK_EXPIRED
      actions.toast.showError(response.error.message);
      location.replace('/forgot-password');
    } else if (errorCode === 5030) {
      // PASSWORD_POLICY_VALIDATION_ERROR_COMPROMISED
      actions.toast.showError(
        'Your chosen password appears to have been compromised. Please enter a different password.'
      );
    } else {
      actions.toast.showError('Something went wrong while trying to reset your password.');
    }
  };

  const handleResetPasswordSuccess = () => {
    location.replace('/login');
  };

  return (
    <PageContent>
      <Container
        css={(theme: Theme) => css`
          padding: ${theme.spacing(2.5)}px;
        `}
        maxWidth="sm"
      >
        <Typography component="h1" mb={2} variant="heading02">
          Reset your password
        </Typography>
        <ResetPasswordForm
          email={emailFromQueryString}
          token={tokenFromQueryString}
          onSubmit={handleResetPassword}
        />
      </Container>
    </PageContent>
  );
};

export default ResetPasswordRoute;
